import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SegmentContactRow } from '../../models/segment-contact-row.model';

const LOAD_MORE_THRESHOLD_PX = 40;

@Component({
  selector: 'app-crm-segment-assigned-contacts',
  standalone: true,
  templateUrl: './crm-segment-assigned-contacts.component.html',
  styleUrls: ['./crm-segment-assigned-contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmSegmentAssignedContactsComponent {
  @Input() contacts: SegmentContactRow[] = [];
  @Input() loading = false;
  @Input() loadingMore = false;
  @Input() totalCount: number | null = null;
  @Input() title = '';
  @Input() emptyMessage = '';

  @Output() loadMore = new EventEmitter<void>();

  get hasMore(): boolean {
    return this.totalCount !== null && this.contacts.length < this.totalCount;
  }

  onListScroll(event: Event): void {
    if (this.loadingMore || !this.hasMore) {
      return;
    }

    const el = event.target as HTMLElement;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < LOAD_MORE_THRESHOLD_PX) {
      this.loadMore.emit();
    }
  }
}
